<template>
  <div>
    <conversations acc-type="Farm" />
  </div>
</template>

<script>
import Conversations from "@/components/shared/Conversations/index.vue";

export default {
  components: {
    Conversations
  }
};
</script>

<style  scoped>
</style>
